import script from "./referenceDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./referenceDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./referenceDetailPage.vue?vue&type=style&index=0&id=fcf2ff26&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fcf2ff26"]])

export default __exports__